import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { BRAND_STORE, BRAND_HASH } from './store.js';
export * from './types.js';
/* eslint-disable arrow-body-style */
// Filter Brands
export const filterBrands = async (parameters = {}) => {
    return PROXY.handleFilter(PEGASUS.filterBrands, parameters)
        .then(brands => PROXY.updateStoreBulk(BRAND_STORE, brands));
};
// Fetch Brand
export const fetchBrand = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchBrand, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        return PROXY.updateStore(BRAND_STORE, null, data);
    });
};
// Create Brand
export const createBrand = async (body) => {
    return PROXY.handleCreate(PEGASUS.createBrand, body)
        .then(response => PROXY.updateStore(BRAND_STORE, BRAND_HASH, response));
};
// Update Brand
export const updateBrand = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateBrand, keys, body)
        .then(response => PROXY.updateStore(BRAND_STORE, BRAND_HASH, response));
};
// Delete Brand
export const deleteBrand = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteBrand, keys)
        .then(response => PROXY.removeFromStore(BRAND_STORE, BRAND_HASH, keys.brandKey, response));
};
// Update Brand State
export const updateBrandState = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateBrandState, keys, body)
        .then(response => PROXY.updateStore(BRAND_STORE, BRAND_HASH, response));
};
/* eslint-enable arrow-body-style */ 
